// Resolves any asset URL (gallery, services, promotions) to the current backend.
// Handles legacy absolute URLs (e.g. preview env) and new relative paths uniformly.
const API_URL = process.env.REACT_APP_BACKEND_URL;
const FILES_PREFIX = "/api/files/";

export function resolveAssetUrl(url) {
  if (!url) return url;
  if (typeof url !== "string") return url;
  const idx = url.indexOf(FILES_PREFIX);
  if (idx >= 0) {
    return `${API_URL}${url.substring(idx)}`;
  }
  return url;
}

// Strip the backend host from an absolute asset URL to keep storage portable.
export function toRelativeAssetUrl(url) {
  if (!url || typeof url !== "string") return url;
  const idx = url.indexOf(FILES_PREFIX);
  if (idx >= 0) return url.substring(idx);
  return url;
}
